document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll('.orla-button');

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('animate');
				}
			});
		},
		{ threshold: 0.2 }
	);

	elements.forEach((el) => observer.observe(el));
});
